'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function infiniteQueryOptions(options) {
  return options;
}

exports.infiniteQueryOptions = infiniteQueryOptions;
//# sourceMappingURL=infiniteQueryOptions.js.map
